import PropTypes from "prop-types";
import React, { Children } from "react";
import styles from "./main-navigation-slide-container.module.css";

function SlideContainer({ index, children }) {
    return (
        <div
            className={styles.slideContainer}
            style={{ transform: `translateX(${index * 100 * -1}%)` }}
        >
            {Children.map(children, (child) => (
                <div className={styles.slide}>{child}</div>
            ))}
        </div>
    );
}

SlideContainer.propTypes = {
    index: PropTypes.number,
    children: PropTypes.node,
};

export default SlideContainer;
